/**
 * Clears in-memory API token when NextAuth session ends.
 * Backend auth uses Nest httpOnly cookie + optional in-memory CstoreToken from login —
 * never from /api/auth/session.
 */

'use client'

import { useEffect } from 'react'
import { useSession } from 'next-auth/react'
import { clearApiToken } from '@/libs/api'

export const useBackendToken = () => {
  const { status } = useSession()

  useEffect(() => {
    if (status === 'unauthenticated') {
      clearApiToken()
    }
  }, [status])
}
